import React, { ReactNode } from 'react';

interface CardProps {
  children: ReactNode;
  className?: string;
  accent?: boolean;
  glow?: boolean;
}

export default function Card({ children, className = '', accent = false, glow = false }: CardProps) {
  return (
    <div className={`card ${accent ? 'card-accent' : ''} ${glow ? 'card-glow' : ''} ${className}`}>
      {children}
    </div>
  );
}
